import { render } from "./form-uploader.vue?vue&type=template&id=436c9326"
import script from "./form-uploader.vue?vue&type=script&lang=js"
export * from "./form-uploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__